import { Reveal, ChapterTag } from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="scroll-mt-20">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-20 sm:px-6 sm:py-28 lg:grid-cols-12 lg:px-8 lg:py-36">
        <div className="lg:col-span-4">
          <Reveal>
            <ChapterTag number="01" label="About Me" />
            <h2 className="mt-4 font-display text-2xl font-bold leading-snug tracking-tight text-[#1C1B1A] sm:text-3xl lg:text-4xl">
              A journey built on learning, structure, and discipline
            </h2>
            <div className="mt-8 hidden h-px w-24 bg-[#E05A10] lg:block" aria-hidden="true" />
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <p
              data-testid="about-journey-text"
              className="text-base leading-relaxed text-[#2D2A26] sm:text-lg"
            >
              My trading journey was difficult during the first two years, but
              consistent learning and practical experience gradually helped me
              turn it into a profitable venture. I founded SAATH Trainings to
              share these lessons and help traders approach the market with
              greater knowledge, structure, and discipline.
            </p>
            <p className="mt-6 border-l-2 border-[#E05A10] pl-6 text-base leading-relaxed text-[#524E48] sm:text-lg">
              Over the last three years, I have trained around 200 people.
              Today, some of my mentees deploy capital ranging from ₹10 lakh to
              ₹1.5 crore, aiming for disciplined monthly profitability.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
